// Tank settings' "Tank type" choice (server/tank-type-change.js has the
// rules). Pure, so the words are tested.

import { FRESHWATER_SUBTYPES } from '../../shared/param-explainers.js';
import { paramLabel, paramLabelLower } from '../../shared/param-labels.js';

// The types a tank can change to: saltwater types only, on a saltwater
// tank (owner, 2026-10-05: the type change is for reef keepers). A
// freshwater tank gets no choice. A choice meant for a keeper still
// planning ("Haven't decided") is offered only to a tank that already has
// it.
export function tankTypeOptions(taxonomy, current) {
  if (FRESHWATER_SUBTYPES.includes(String(current || ''))) return [];
  return (taxonomy?.subtypes?.saltwater || [])
    .filter((o) => o && o.k && (!o.only_intent || o.k === current))
    .map((o) => ({ ...o, water: 'saltwater' }));
}

function names(keys, first) {
  const words = keys.map((k, i) => (i === 0 && first ? paramLabel(k) : paramLabelLower(k)));
  if (words.length <= 1) return words[0] || '';
  return `${words.slice(0, -1).join(', ')} and ${words[words.length - 1]}`;
}

// What the save changed, in the keeper's words.
export function typeChangeMessage(change, typeLabel) {
  if (!change) return 'Saved.';
  const out = [typeLabel ? `Saved. Tank type: ${typeLabel}.` : 'Saved.'];
  const shown = change.shown || [];
  const hidden = change.hidden || [];
  if (shown.length) {
    out.push(`${names(shown, true)} ${shown.length === 1 ? 'is' : 'are'} on Home now.`);
  }
  if (hidden.length) {
    out.push(
      `${names(hidden, true)} ${hidden.length === 1 ? 'is' : 'are'} hidden from Home, history kept; turn ${hidden.length === 1 ? 'it' : 'them'} back on in Parameters.`
    );
  }
  const moved = change.moved || [];
  const kept = change.kept || [];
  if (moved.length) {
    out.push(
      `${names(moved, true)} ${moved.length === 1 ? 'uses' : 'use'} this type’s usual range now; check ${moved.length === 1 ? 'it' : 'them'} in Parameters.`
    );
  }
  if (kept.length) {
    out.push(
      `${names(kept, true)} ${kept.length === 1 ? 'keeps its' : 'keep their'} own range; change ${kept.length === 1 ? 'it' : 'them'} in Parameters if you like.`
    );
  }
  return out.join(' ');
}
